import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=59619fb5&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=59619fb5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeroSmall: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/hero/Small.vue').default,IconsArrowRight: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/ArrowRight.vue').default,IconsFacebookF: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/FacebookF.vue').default,IconsLinkedin: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Linkedin.vue').default,IconsTwitter: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Twitter.vue').default,ArticlesTile: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/articles/Tile.vue').default})
